<div class="layout-wrapper" data-cy="layout-wrapper">
    <app-topbar
        (tabClicked)="handleTabClick($event)"
        (logoutClicked)="handleLogoutClicked()"
        (settingsClicked)="handleSettingsClicked()"
        (changeCentersClicked)="handleChangeCentersClicked()"
    ></app-topbar>
    <div class="layout-main-container" data-cy="layout-main-container">
        <div class="layout-main" data-cy="layout-main">
            <router-outlet></router-outlet>
        </div>
    </div>
    <div class="layout-mask" data-cy="layout-mask"></div>
</div>

<app-loader data-cy="global-loader" />
<p-toast key="global-toast" position="bottom-right" data-cy="global-toast"></p-toast>
<p-confirmDialog header="Confirmation" icon="fa-solid fa-question-circle" width="425" data-cy="global-confirm-dialog" />
